import React from 'react';
import { Layout } from '../components/Layout';
import { Container } from '../components/ui/Container';
export function TermsPage() {
  return <Layout data-id="element-704">
      <div className="bg-slate-50 py-12 border-b border-slate-200" data-id="element-705">
        <Container data-id="element-706">
          <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-707">
            Terms & Conditions
          </h1>
          <p className="text-slate-600" data-id="element-708">
            Last Updated: {new Date().toLocaleDateString()}
          </p>
        </Container>
      </div>

      <Container className="py-16 max-w-4xl" data-id="element-709">
        <div className="prose prose-slate max-w-none space-y-8" data-id="element-710">
          <section data-id="element-711">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-712">
              1. Agreement to Terms
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-713">
              By accessing or using the website danycredit.com (the "Website")
              and the services provided by DanyCredit LLC ("we," "our," or
              "us"), you agree to be bound by these Terms and Conditions
              ("Terms"). If you do not agree with any part of these Terms, you
              must not use our Website or services.
            </p>
            <div className="bg-blue-50 border-l-4 border-blue-600 p-4 my-4" data-id="element-714">
              <p className="text-sm text-blue-900 font-medium" data-id="element-715">
                Important: Use of this website does not create a client–advisor,
                legal, or lender relationship. DanyCredit provides educational
                and consulting services only.
              </p>
            </div>
          </section>

          <section data-id="element-716">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-717">
              2. Description of Services
            </h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-718">
              2.1 Educational and Consulting Services
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-719">
              DanyCredit LLC provides educational and consulting services
              related to credit understanding, financial planning basics, and
              credit readiness. Our services include:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-720">
              <li data-id="element-721">Credit profile review and analysis</li>
              <li data-id="element-722">Credit education and strategy development</li>
              <li data-id="element-723">Financial planning guidance</li>
              <li data-id="element-724">Credit readiness consulting</li>
              <li data-id="element-725">Business credit education (consulting only)</li>
            </ul>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-726">
              2.2 What We Are NOT
            </h3>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-727">
              DanyCredit LLC is NOT:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-728">
              <li data-id="element-729">
                A credit repair organization as defined by the Credit Repair
                Organizations Act (CROA)
              </li>
              <li data-id="element-730">A credit bureau or credit reporting agency</li>
              <li data-id="element-731">A lender or financial institution</li>
              <li data-id="element-732">A law firm or legal service provider</li>
              <li data-id="element-733">A debt settlement or debt consolidation company</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-734">
              We do not dispute accurate negative items on your behalf, provide
              legal advice, or offer lending services.
            </p>
          </section>

          <section data-id="element-735">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-736">
              3. No Guarantees or Warranties
            </h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-737">
              3.1 Results Not Guaranteed
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-738">
              We do NOT guarantee any specific outcomes, including but not
              limited to:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-739">
              <li data-id="element-740">Credit score increases or improvements</li>
              <li data-id="element-741">Removal of negative items from credit reports</li>
              <li data-id="element-742">Loan or credit approvals</li>
              <li data-id="element-743">Specific financial results or outcomes</li>
              <li data-id="element-744">Timeframes for achieving any financial goals</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-745">
              Results vary significantly based on individual financial profiles,
              credit history, and actions taken by the client.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-746">
              3.2 Educational Nature
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-747">
              All information, guidance, and strategies provided by DanyCredit
              are for educational purposes only. They should not be considered
              as financial, legal, or tax advice. You are solely responsible for
              your financial decisions and should consult with appropriate
              licensed professionals before making significant financial
              commitments.
            </p>
          </section>

          <section data-id="element-748">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-749">
              4. User Responsibilities
            </h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-750">
              4.1 Accurate Information
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-751">
              You agree to provide accurate, current, and complete information
              when using our services. You are responsible for maintaining the
              accuracy of your information and promptly updating any changes.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-752">
              4.2 Compliance with Laws
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-753">
              You agree to use our services in compliance with all applicable
              federal, state, and local laws and regulations. You will not use
              our services for any unlawful or fraudulent purpose.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-754">
              4.3 Implementation
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-755">
              You are solely responsible for implementing any strategies or
              recommendations provided during consultations. DanyCredit is not
              responsible for the outcomes of actions you choose to take based
              on our educational guidance.
            </p>
          </section>

          <section data-id="element-756">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-757">
              5. Payment Terms
            </h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-758">
              5.1 Fees and Billing
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-759">
              Fees for our services are clearly stated on our Pricing page and
              during the consultation booking process. All fees are charged for
              professional time and expertise, not for specific outcomes or
              results.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-760">
              5.2 Payment Processing
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-761">
              Payments are processed securely through third-party payment
              processors. By providing payment information, you authorize us to
              charge the applicable fees to your payment method.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-762">
              5.3 Recurring Payments
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-763">
              For monthly or recurring services, you authorize automatic billing
              at the specified intervals until you cancel. You may cancel
              recurring services at any time by contacting us at
              info@danycredit.com.
            </p>
          </section>

          <section data-id="element-764">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-765">
              6. Limitation of Liability
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-766">
              To the fullest extent permitted by law, DanyCredit LLC, its
              officers, directors, employees, and agents shall not be liable for
              any indirect, incidental, special, consequential, or punitive
              damages, including but not limited to:
            </p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-767">
              <li data-id="element-768">Loss of profits, revenue, or business opportunities</li>
              <li data-id="element-769">Loss of data or information</li>
              <li data-id="element-770">Financial losses resulting from credit decisions</li>
              <li data-id="element-771">Damages resulting from reliance on information provided</li>
              <li data-id="element-772">Any other indirect or consequential damages</li>
            </ul>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-773">
              Our total liability for any claims arising from or related to our
              services shall not exceed the amount you paid for the specific
              service giving rise to the claim.
            </p>
          </section>

          <section data-id="element-774">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-775">
              7. Intellectual Property
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-776">
              All content on the Website, including but not limited to text,
              graphics, logos, images, videos, software, and other materials, is
              the property of DanyCredit LLC and is protected by United States
              and international copyright, trademark, and other intellectual
              property laws.
            </p>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-777">
              You may not reproduce, distribute, modify, create derivative works
              from, publicly display, or exploit any content from our Website
              without our express written permission.
            </p>
          </section>

          <section data-id="element-778">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-779">
              8. Confidentiality
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-780">
              We treat all client information as confidential and will not
              disclose your personal or financial information to third parties
              except as outlined in our Privacy Policy or as required by law.
            </p>
          </section>

          <section data-id="element-781">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-782">
              9. Termination
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-783">
              We reserve the right to terminate or suspend your access to our
              services at any time, without notice, for conduct that we believe
              violates these Terms, is harmful to other users, or is otherwise
              inappropriate.
            </p>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-784">
              You may terminate your use of our services at any time by
              contacting us. Upon termination, your right to use our services
              will immediately cease.
            </p>
          </section>

          <section data-id="element-785">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-786">
              10. Dispute Resolution
            </h2>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-787">
              10.1 Governing Law
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-788">
              These Terms shall be governed by and construed in accordance with
              the laws of the State of Florida, without regard to its conflict
              of law provisions.
            </p>

            <h3 className="text-xl font-semibold text-slate-900 mb-3 mt-6" data-id="element-789">
              10.2 Jurisdiction
            </h3>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-790">
              Any disputes arising from or relating to these Terms or our
              services shall be resolved in the state or federal courts located
              in Miami-Dade County, Florida. You consent to the exclusive
              jurisdiction of these courts.
            </p>
          </section>

          <section data-id="element-791">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-792">
              11. Changes to Terms
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-793">
              We reserve the right to modify these Terms at any time. We will
              notify users of material changes by posting the updated Terms on
              our Website with a new "Last Updated" date. Your continued use of
              our services after such changes constitutes acceptance of the
              updated Terms.
            </p>
          </section>

          <section data-id="element-794">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-795">
              12. Severability
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-796">
              If any provision of these Terms is found to be invalid or
              unenforceable, the remaining provisions shall continue in full
              force and effect.
            </p>
          </section>

          <section data-id="element-797">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-798">
              13. Entire Agreement
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-799">
              These Terms, together with our Privacy Policy and Refund Policy,
              constitute the entire agreement between you and DanyCredit LLC
              regarding the use of our services and supersede all prior
              agreements and understandings.
            </p>
          </section>

          <section data-id="element-800">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-801">
              14. Contact Information
            </h2>
            <p className="text-slate-700 leading-relaxed mb-3" data-id="element-802">
              If you have questions or concerns about these Terms, please
              contact us:
            </p>
            <div className="bg-slate-50 border border-slate-200 rounded-lg p-6 mt-4" data-id="element-803">
              <p className="font-semibold text-slate-900 mb-2" data-id="element-804">
                DanyCredit LLC
              </p>
              <p className="text-slate-700" data-id="element-805">390 NE 191ST ST STE 8123</p>
              <p className="text-slate-700" data-id="element-806">Miami, FL 33179</p>
              <p className="text-slate-700 mt-3" data-id="element-807">Email: info@danycredit.com</p>
              <p className="text-slate-700" data-id="element-808">Phone: 786-376-3985</p>
            </div>
          </section>

          <div className="bg-amber-50 border-l-4 border-amber-600 p-6 mt-8" data-id="element-809">
            <p className="text-sm text-amber-900 font-medium mb-2" data-id="element-810">
              Disclaimer
            </p>
            <p className="text-sm text-amber-800 leading-relaxed" data-id="element-811">
              DanyCredit LLC provides educational and consulting services only.
              We do not guarantee specific outcomes, credit score increases,
              approvals, or financial results. We are not a credit bureau,
              lender, or law firm. Results vary by individual financial profile.
              Use of this website does not create a client–advisor, legal, or
              lender relationship.
            </p>
          </div>
        </div>
      </Container>
    </Layout>;
}